import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '@common/common.action';
import { ModalImprimirPage } from './modal.imprimir.page';
import WebapiCommon from '@common/util/webapi.common';
import ConfiguracaoApi from '../../../../configuracao/configuracao.api';
import Preview from '@componentes/PreviewURL';
import { etapasEnum, statusEtapasEnum } from '@util/defaultValues';
class ModalImprimirContainer extends Component {
  constructor () {
    super();
    this.state = {
      itemCarregado: false,
      labelNotas: etapasEnum.NOTAS,
      etapas: [],
      show: false,
      url: '',
      pdfbase64: '',
    };
  }

  componentDidMount () {
    ConfiguracaoApi.getConfiguracaoGeral().then(res => {
      this.setState({ labelNotas: res.nomeExibicaoEtapaNotas.toUpperCase() });
    });
    if (this.props.textoProtocoloEntregaMaterial === '') {
      WebapiCommon.getConfiguracaoEngrega().then(response => {
        this.props.commonActions.preencherTextoProtocoloMaterial(
          response.textoEntregaMaterial
        );
      });
    }
  }

  componentDidUpdate () {
    if (
      !this.state.itemCarregado &&
      this.props.modalImprimir &&
      this.props.laudoImprimir
    ) {
      var etapas = [];
      this.props.laudoImprimir.etapas.forEach(et => {
        if (et.etapa !== etapasEnum.MATERIAL) {
          var disabled = true;
          if (
            et.status !== statusEtapasEnum.NAO_REALIZADO &&
            et.status !== statusEtapasEnum.NAO_APLICAVEL
          )
            disabled = false;
          var etapa = { ...et, ...{ checked: !disabled, disabled } };
          etapas.push(etapa);
        }
      });
      this.setState({ etapas, itemCarregado: true });
    }
  }

  setShow (show) {
    this.setState({ show });
    if (!show) {
      this.closeModal();
    }
  }

  checkedEtapa (nomeEtapa, value) {
    var etps = Object.assign(this.state.etapas);
    this.setState({
      etapas: etps.map(et => {
        if (et.etapa === nomeEtapa) {
          et.checked = value;
        }
        return et;
      })
    });
  }

  imprimirLaudos () {
    var etapas = [];
    this.state.etapas.forEach(et => {
      if (et.checked) {
        etapas.push(et.etapa);
      }
    });

    this.props.commonActions.showFadeCarregando(true);

    WebapiCommon.imprimirLaudo(
      this.props.laudoImprimir.laudo,
      etapas,
      'clawPDF'
    ).then(data => {
      this.props.commonActions.showFadeCarregando(false);
      this.setState({ pdfbase64: data.pdf });
      this.setShow(!this.state.show);
    });
  }

  closeModal () {
    this.props.commonActions.mudarStatusModalImprimir(false, undefined);
    this.setState({ etapas: [], itemCarregado: false });
  }

  render () {
    return (
      <React.Fragment>
        <Preview
          show={this.state.show}
          setShow={this.setShow.bind(this)}
          url={this.state.url}
          pdf={this.state.pdfbase64}
        />
        <ModalImprimirPage
          labelNotas={this.state.labelNotas}
          openModalImprimir={this.props.modalImprimir}
          etapas={this.state.etapas}
          checkedEtapa={this.checkedEtapa.bind(this)}
          imprimirLaudos={this.imprimirLaudos.bind(this)}
          altura={parseInt(this.props.altura, 10) - 30}
          closeModal={this.closeModal.bind(this)}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    modalImprimir: state.commonReducer.modalImprimir,
    laudoImprimir: state.commonReducer.laudoImprimir
  };
};

const mapDispacthToProps = dispatch => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispacthToProps
)(ModalImprimirContainer);



// WEBPACK FOOTER //
// ./src/pages/main/listagem/modais/imprimir_laudo/modal.imprimir.container.js